import React, { useEffect, useState } from 'react';
import { useQuestionToggleAtom } from '../atoms/chat/useQuestionToggleAtom';
import { responseInterceptor } from '../api/axios';

import ChatWindow from '../components/chat/ChatWindow';

const Page = () => {
  const [isQuestionsVisible] = useQuestionToggleAtom();
  const [, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
    responseInterceptor();
  }, []);
  
  
  return (
      <div id="mainContainer" className={`container ${isQuestionsVisible ? 'close' : 'open'}`}>
        {/* <ErrorBoundary fallback={<div>Something went wrong</div>}> */}
        <ChatWindow />
        {/* </ErrorBoundary> */}
      </div> 
  );
}

export default Page;
